import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { PlansDetails } from "../FetchAPI";
import "./CheckoutPlansCSS.css";
import LegalBradcrumeSection from "../Community/LegalBradcrumeSection";
import NotifyMessageNoReload from "../Others/NotifyMessageNoReload";

import CheckoutEnquiryValidation from "./CheckoutEnquiryValidation";
import APIDataFetchLoader from "../Others/APIDataFetchLoader";
import { formatPrice } from "../Others/ImportantFunction";
import { useAuth } from "../../Store/AuthContext";
import { Helmet } from "react-helmet";
import getepayPortal from "./Getepay_pg_node/index";

const SiteUrl = process.env.REACT_APP_SITEURL;
// const PAYMENTKEY = process.env.REACT_APP_PAYMENTKEY;
// const PAYMENTKEYSECRET = process.env.REACT_APP_PAYMENTKEYSECRET;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function CheckoutPlans() {
  const { userID, userRoll, RendomTokenfetch, profileData } = useAuth();

  const navigate = useNavigate();
  // const location = useLocation();
  let { planslug } = useParams();

  // console.log(vendorRollID);
  const [planDetails] = PlansDetails(RendomTokenfetch, planslug, userRoll);
  // console.log(planDetails);

  const planid = planDetails.id;

  // useEffect(() => {
  //   if (localStorage.getItem("userid") === null) {
  //     NotifyMessageNoReload(
  //       "Please login After Book Services!",
  //       "danger",
  //       true
  //     );
  //     navigate("/login", { state: { from: location.pathname } });
  //   }
  // }, [navigate, location]);

  const PlanPrice = Number(planDetails.selling_price);

  const SellingPrice = formatPrice(PlanPrice);
  const FormattedTotalPrice = SellingPrice;

  // console.log(planDetails);

  const nameref = useRef(profileData?.username || "");
  const emailref = useRef(profileData?.email || "");

  const [description, setdescriptions] = useState("");
  const addreshref = useRef(profileData?.address || "");

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedState, setSelectedState] = useState("");
  const [selectedcity, setSelectedcity] = useState("");

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const [formValiderror, setformValiderror] = useState({});
  // console.log(formValiderror);
  const [selectedPayment, setSelectedPayment] = useState("");

  const handlePaymentMethod = (event) => {
    setSelectedPayment(event.target.value);
    setformValiderror({});
  };

  useEffect(() => {
    if (planDetails?.state_id) {
      setSelectedState(planDetails.state_id);
    }
    if (planDetails?.city_id) {
      setSelectedcity(planDetails.city_id);
    }
  }, [planDetails]);

  // Fetch States
  useEffect(() => {
    setLoading(true);
    const FetchSubServiceStateData = async () => {
      try {
        await axios
          .get(`${WebsiteAPIurl}getAllState`, {
            params: { country_id: "101" },
          })
          .then((response) => {
            if (response.data.Status === "1") {
              setStates(response.data.allstateData || []);
              setCities([]);
            } else {
              setStates([]);
              setCities([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchSubServiceStateData();
  }, [RendomTokenfetch]);

  // Fetch cities when state changes
  useEffect(() => {
    setLoading(true);
    const FetchServiceCityData = async () => {
      try {
        await axios
          .get(`${WebsiteAPIurl}getAllCity`, {
            params: { state_id: selectedState },
          })
          .then((response) => {
            if (response.data.Status === "1") {
              setCities(response.data.allcityData || []);
            }
            if (response.data.Status === "0") {
              setCities([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchServiceCityData();
  }, [RendomTokenfetch, selectedState]);

  const [mobileNumber, setMobileNumber] = useState("");
  //   const [whatsappNumber, setWhatsappNumber] = useState("");

  useEffect(() => {
    if (profileData?.number) {
      setMobileNumber(profileData.number);
    }
  }, [profileData]);

  const handleKeyPress = (e) => {
    const charCode = e.which || e.keyCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setMobileNumber(value);
      //   setWhatsappNumber(value);
    }
  };
  // const [paymentId, setpaymentId] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("userroll", userRoll);
    fdata.append("planid", planid);
    fdata.append("name", nameref.current?.value || "");
    fdata.append("email", emailref.current?.value || "");
    fdata.append("number", mobileNumber);
    fdata.append("state", selectedState);
    fdata.append("city", selectedcity);
    fdata.append("address", addreshref.current?.value || "");
    fdata.append("description", description);
    fdata.append("payment_method", selectedPayment);

    axios
      .post(`${WebsiteAPIurl}leadAdd`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (
          nameref.current?.value &&
          mobileNumber &&
          emailref.current.value &&
          selectedPayment
        ) {
          if (response.data.Status === "1") {
            if (response.data.payment_method === "1") {
              const paymentData = response.data.payment_data;
              console.log(response.data);

              const data = {
                mid: 108,
                amount: paymentData.amount,
                merchantTransactionId: `TXN${Date.now()}`,
                transactionDate: new Date().toString(),
                terminalId: "Getepay.merchant61062@icici",
                udf1: "7891243236",
                udf2: "kumawatnavratna874@gmail.com",
                udf3: "Test",
                udf4: "",
                udf5: "",
                udf6: "",
                udf7: "",
                udf8: "",
                udf9: "",
                udf10: "",
                // ru: "https://yourdomain.com/api/Webapi/payment-response.php",
                ru: "https://pay1.getepay.in:8443/getepayPortal/pg/pgPaymentResponse",
                callbackUrl: "",
                currency: "INR",
                paymentMode: "ALL",
                bankId: "",
                txnType: "single",
                productType: "IPG",
                txnNote: "Test Txn",
                vpa: "Getepay.merchant61062@icici",
              };

              const config = {
                GetepayMid: 108,
                GeepayTerminalId: "Getepay.merchant61062@icici",
                GetepayKey: "JoYPd+qso9s7T+Ebj8pi4Wl8i+AHLv+5UNJxA3JkDgY=",
                GetepayIV: "hlnuyA9b4YxDq6oJSZFl8g==",

                GetepayUrl:
                  "https://pay1.getepay.in:8443/getepayPortal/pg/generateInvoice",
              };

              getepayPortal(data, config);

              // const funcRes =  (response)  => {
              //   if (paymentId) {
              //     let PaymentOrderdata = new FormData();
              //     PaymentOrderdata.append("order_id", paymentData.order_id);
              //     PaymentOrderdata.append("payment_id", paymentId);
              //     PaymentOrderdata.append(
              //       "signature",
              //       response.razorpay_signature
              //     );

              //     axios
              //       .post(
              //         `${WebsiteAPIurl}paymentorderupdate`,
              //         PaymentOrderdata,
              //         {
              //           headers: {
              //             Authorization: RendomTokenfetch,
              //           },
              //         }
              //       )
              //       .then((response) => {
              //         console.log(response.data);
              //         if (response.data.Status === "1") {
              //           NotifyMessageNoReload(
              //             response.data.msg,
              //             "success",
              //             true
              //           );
              //           // Optionally, navigate or refresh state here
              //         } else {
              //           NotifyMessageNoReload(
              //             response.data.msg,
              //             "danger",
              //             true
              //           );
              //         }
              //       })
              //       .catch((err) => {
              //         console.error("Payment verification error:", err);
              //         NotifyMessageNoReload(
              //           "Something went wrong!",
              //           "danger",
              //           true
              //         );
              //       })
              //       .finally(() => {
              //         setLoading(false); // if you're managing loading states
              //       });
              //   } else {
              //     NotifyMessageNoReload("Payment Failed!", "danger", true);
              //   }
              // }

              // NotifyMessageNoReload(response.data.msg, "success", "top-right");
            } else {
              NotifyMessageNoReload(response.data.msg, "success", true);
              navigate("/service-booking");
            }
          } else {
            NotifyMessageNoReload(response.data.msg, "danger", true);
            setformValiderror(
              CheckoutEnquiryValidation(response.data?.form_validation || {})
            );
          }
        } else {
          NotifyMessageNoReload(response.data.msg, "danger", true);
          setformValiderror(
            CheckoutEnquiryValidation(response.data?.form_validation || {})
          );
        }
      });
  };

  if (loading) {
    return <APIDataFetchLoader />;
  }
  if (error) {
  }

  return (
    <>
      <Helmet>
        <title>{planDetails.meta_title}</title>
        <meta name="description" content={planDetails.meta_description} />
        <meta name="keywords" content={planDetails.meta_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <LegalBradcrumeSection
        Pagename={planDetails.plan_title}
        page1={[
          { name: "Service", pagelink: "services" },
          { name: "Checkout" },
          { name: planDetails.plan_title },
        ]}
      />

      <section className="shop-single serviceChecket">
        <div className="auto-container">
          <div className="product-details mb-0">
            <div className="basic-details mb-0">
              <form
                className=" was-validated checkoutForm default-form defaultForm"
                onSubmit={handleSubmit}
              >
                <div className="row clearfix">
                  <div className="image-column col-md-8 col-sm-12 mb-0">
                    <h5 className="mb-3 fw-700">Booking Details</h5>
                    {/* Booking Form  */}

                    <div className="row">
                      <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                        <label className="form-label" htmlFor="name">
                          Name
                        </label>

                        <input
                          type="text"
                          name="name"
                          ref={nameref}
                          defaultValue={profileData?.username || ""}
                          className="form-control"
                          // readOnly={!!profileData?.firstname}
                          required
                        />

                        {formValiderror.name && (
                          <span className="text-danger">
                            * {formValiderror.name}
                          </span>
                        )}
                      </div>
                      <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                        <label htmlFor="name">Email</label>
                        <input
                          type="email"
                          name="email"
                          ref={emailref}
                          defaultValue={profileData?.email || ""}
                          className="form-control"
                          // readOnly={!!profileData?.email}
                          required
                        />
                      </div>

                      <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                        <label>Mobile Number</label>
                        <div className="input-group">
                          <span className="input-group-text">91</span>
                          <input
                            type="text"
                            className="form-control w-50"
                            name="mobileNumber"
                            onChange={handleMobileChange}
                            onKeyPress={handleKeyPress}
                            value={mobileNumber}
                            maxLength={10}
                            inputMode="numeric"
                            // readOnly={vendorRollID !== "1"}
                            required
                          />
                        </div>

                        {formValiderror.number && (
                          <span className="text-danger">
                            * {formValiderror.number}
                          </span>
                        )}
                      </div>

                      <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                        <label>State</label>

                        <select
                          className="form-control"
                          value={selectedState}
                          onChange={(e) => setSelectedState(e.target.value)}
                        >
                          <option value="">Select State</option>
                          {states.map((state, index) => (
                            <option value={state.id} key={index}>
                              {state.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                        <label>City</label>
                        <select
                          className="form-control"
                          value={selectedcity}
                          onChange={(e) => setSelectedcity(e.target.value)}
                          disabled={!cities.length}
                        >
                          <option value="">Select City</option>
                          {cities.map((city, index) => (
                            <option value={city.id} key={index}>
                              {city.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group col-lg-12 col-md-12 mb-3">
                        <label>Address</label>
                        <textarea
                          className="form-control"
                          placeholder=""
                          rows={2}
                          ref={addreshref}
                          defaultValue={profileData?.address || ""}
                        ></textarea>
                      </div>

                      <div className="form-group col-lg-12 col-md-12 mb-3">
                        <label>Message</label>
                        <textarea
                          value={description}
                          onChange={(e) => setdescriptions(e.target.value)}
                          rows={4}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="info-column col-md-4 col-sm-12 cheoutDeatls mb-0">
                    <div className="order-box">
                      <h3 className="checketheading">Your Plans Book</h3>
                      <table>
                        <thead>
                          <tr>
                            <th>
                              <strong>Plans</strong>
                            </th>
                            <th>
                              <strong>Subtotal</strong>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="cart-item">
                            <td className="servicename">
                              {planDetails.plan_title}
                            </td>
                            <td className="servicetotal">{SellingPrice}</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr className="serviceordertotal">
                            <td>Total</td>
                            <td>
                              <span className="amount">
                                {FormattedTotalPrice}
                              </span>
                            </td>
                          </tr>
                        </tfoot>
                      </table>

                      <ul className="product-meta mt-2">
                        <span className="plasdetDECS mb-2 d-block">
                          Payment Methods* :
                        </span>{" "}
                        <li>
                          <ul
                            style={{ listStyleType: "disc" }}
                            className="plnasfeatureBox "
                          >
                            {/* <li className="plnasfeatureLi m-3"></li> */}
                            {/* <li className="plnasfeatureLi">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  id="onlinepayment"
                                  name="paymentmethod"
                                  className="form-check-input paymentmethoinputcss"
                                  value={"1"}
                                  onChange={handlePaymentMethod}
                                  required
                                />
                                <label
                                  htmlFor="onlinepayment"
                                  className="form-check-label remember verifycheckbx"
                                >
                                  Online Payment
                                </label>
                              </div>
                            </li> */}
                            <li className="plnasfeatureLi">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  id="payafter"
                                  name="paymentmethod"
                                  value={"0"}
                                  onChange={handlePaymentMethod}
                                  className="form-check-input paymentmethoinputcss"
                                  required
                                />
                                <label
                                  htmlFor="payafter"
                                  className="form-check-label remember verifycheckbx"
                                >
                                  Pay After
                                </label>
                              </div>
                            </li>
                          </ul>
                        </li>
                      </ul>

                      <div className="col-lg-12 col-md-12 text-center mt-3">
                        <button className="theme-btn btn-style-three">
                          Service Book
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
